import React, { useState, useEffect } from "react"
import Select from "react-select"
import api from "../../../base/services/ResApi"

const APKDropdown = (props) => {
  const [data, setData] = useState([])

  let apprvConfig = {
    headers: {
      Action: "V_ALL_APPR_APP",
      "Is-Pagination": "false",
      "Sort-Column": "version_code",
      "Sort-Order": "desc",
      Filter: "F_ORG_CODE",
      Value: props.orgCode,
    },
  }
  useEffect(() => {
    const fetchData = () => {
      api
        .get("/applications", apprvConfig)
        .then((res) => {
          setData(res.data?.dataList)
          props.setRefresh(false)
        })
        .catch((error) => {
          console.log(error)
        })
    }
      fetchData()

  }, [props.orgCode, props.isRefresh])

  return (
    <div>
      <Select
        name={props.name}
        onChange={props.onChange}
        options={data}
        getOptionLabel={(e) => e.appName}
        getOptionValue={(e) => e.applicationId}
        placeholder="Select APK"
        isClearable
        isDisabled={props.isDisabled}
      />
    </div>
  )
}

export default APKDropdown
